export const timepickerSettings = Object.freeze({
  DEFAULT_INTERVAL: 5,
  FIFTEEN_MINUTE_INTERVAL: 15,
  HALF_HOUR_INTERVAL: 30,
});
